var React = require('react');

function X (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: none;\n        stroke: #707070;\n        stroke-linecap: round;\n        stroke-width: 2px;\n      }\n    ")),React.createElement("g",{"id":"グループ_1306","data-name":"グループ 1306","transform":"translate(-295.086 -9.086)","key":1},[React.createElement("line",{"id":"線_676","data-name":"線 676","className":"cls-1","x1":"12","y2":"12","transform":"translate(296.5 10.5)","key":0}),React.createElement("line",{"id":"線_677","data-name":"線 677","className":"cls-1","x2":"12","y2":"12","transform":"translate(296.5 10.5)","key":1})])]);
}

X.defaultProps = {"width":"14.828","height":"14.828","viewBox":"0 0 14.828 14.828"};

module.exports = X;

X.default = X;
